<template>
  <div class="w-100 h-100">
    <h2>Consortium Report</h2>
    <span style="font-style: italic;">Study Breakdown Report and Downloads</span>
    <b-button variant="success" style="float: right; position: relative; top: -20px; margin-right: 20px;" @click="download_pdf">Download PDF</b-button>
    <hr />
    <!-- Enrollment Process -->
    <b-card title="Enrollment">
      <b-card-text style="padding-left: 40px;">
      <b-row>
        <b-col cols="4">
          <b-card title="" class="list-group-item-warning clickable" @click="download_subset('assessed')">
            <b-card-text>
              <h4>Assessed: <b-badge v-if="assessed" style="float: right;">{{ assessed }}</b-badge><b-badge v-else style="float: right;"><i class="fa fa-spinner fa-spin"></i></b-badge></h4>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card title="" class="list-group-item-success clickable" @click="download_subset('randomized')">
            <b-card-text>
              <h4>Randomized: <b-badge v-if="randomized" style="float: right;">{{ randomized }}</b-badge><b-badge v-else style="float: right;"><i class="fa fa-spinner fa-spin"></i></b-badge></h4>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card title="" class="list-group-item-danger clickable" @click="download_subset('excluded')">
            <b-card-text>
              <h4>Excluded: <b-badge v-if="excluded" style="float: right;">{{ excluded }}</b-badge><b-badge v-else style="float: right;"><i class="fa fa-spinner fa-spin"></i></b-badge></h4>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      </b-card-text>
    </b-card>

    <b-row style="margin-top: 10px; margin-bottom: 10px;">
      <b-col style="text-align: right;"><i class="fa fa-arrow-down" style="padding-right: 60px;"></i></b-col>
      <b-col><i class="fa fa-arrow-down" style="padding-left: 60px;"></i></b-col>
    </b-row>

    <!-- Allocation Process -->
    <b-row>
      <!-- Placebo -->
      <b-col>
        <b-card title="Placebo Allocation">
          <b-card-text style="padding-left: 40px;">
          <b-row>
            <b-col>
              <b-card title="" class="list-group-item-info clickable" @click="download_subset('placebo-allocation')">
                <b-card-text>
                  <h4>Subjects assessed for eligibility: <b-badge v-if="placebo_elibility" style="float: right;">{{ placebo_elibility }}</b-badge><b-badge v-else style="float: right;"><i class="fa fa-spinner fa-spin"></i></b-badge></h4>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
          </b-card-text>
        </b-card>
      </b-col>

      <!-- Product -->
      <b-col>
        <b-card title="Product Allocation">
          <b-card-text style="padding-left: 40px;">
          <b-row>
            <b-col>
              <b-card title=""  class="list-group-item-primary clickable" @click="download_subset('product-allocation')">
                <b-card-text>
                  <h4>Subjects assessed for eligibility: <b-badge v-if="product_elibility" style="float: right;">{{ product_elibility }}</b-badge><b-badge v-else style="float: right;"><i class="fa fa-spinner fa-spin"></i></b-badge></h4>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <b-row style="margin-top: 10px; margin-bottom: 10px;">
      <b-col style="text-align: center;"><i class="fa fa-arrow-down"></i></b-col>
      <b-col style="text-align: center;"><i class="fa fa-arrow-down"></i></b-col>
    </b-row>

    <!-- Follow Up -->
    <b-row>
      <!-- Placebo -->
      <b-col>
        <b-card title="Placebo Follow-up">
          <b-card-text style="padding-left: 40px;">
          <b-row>
            <b-col>
              <b-card title="Lost to Follow-up" class="list-group-item-info clickable" @click="download_subset('placebo-followup')">
                <b-card-text>
                  <b-table striped hover :items="placebo_ltfu" :fields="reasons_fields" thead-class="hidden_header">
                    <template v-slot:cell(n)="data">
                      <b-badge v-if="data.value">{{ data.value }}</b-badge><b-badge v-else style="float: right;"><i class="fa fa-spinner fa-spin"></i></b-badge>
                    </template>
                  </b-table>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
          </b-card-text>
        </b-card>
      </b-col>

      <!-- Product -->
      <b-col>
        <b-card title="Product Follow-up">
          <b-card-text style="padding-left: 40px;">
          <b-row>
            <b-col>
              <b-card title="Lost to Follow-up"  class="list-group-item-primary clickable" @click="download_subset('product-followup')">
                <b-card-text>
                   <b-table striped hover :items="product_ltfu" :fields="reasons_fields" thead-class="hidden_header">
                    <template v-slot:cell(n)="data">
                      <b-badge v-if="data.value">{{ data.value }}</b-badge><b-badge v-else style="float: right;"><i class="fa fa-spinner fa-spin"></i></b-badge>
                    </template>
                  </b-table>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <b-row style="margin-top: 10px; margin-bottom: 10px;">
      <b-col style="text-align: center;"><i class="fa fa-arrow-down"></i></b-col>
      <b-col style="text-align: center;"><i class="fa fa-arrow-down"></i></b-col>
    </b-row>

    <!-- Analysis -->
    <b-row>
      <!-- Placebo -->
      <b-col>
        <b-card title="Placebo Analysis">
          <b-card-text style="padding-left: 40px;">
          <b-row>
            <b-col>
              <b-card title="" class="list-group-item-info clickable" @click="download_subset('placebo-analysis')">
                <b-card-text>
                  <h4>Cases analysed: <b-badge style="float: right;">{{ placebo_analysed }}</b-badge></h4>
                </b-card-text>
              </b-card>
              <br />
              <b-card title="Excluded From Analysis"  class="list-group-item-info clickable" @click="download_subset('placebo-excluded-analysis')">
                <b-card-text>
                   <b-table striped hover :items="product_excluded_analysis" :fields="reasons_fields" thead-class="hidden_header">
                    <template v-slot:cell(n)="data">
                      <b-badge>{{ data.value }}</b-badge>
                    </template>
                  </b-table>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
          </b-card-text>
        </b-card>
      </b-col>

      <!-- Product -->
      <b-col>
        <b-card title="Product Analysis">
          <b-card-text style="padding-left: 40px;">
          <b-row>
            <b-col>
              <b-card title=""  class="list-group-item-primary clickable" @click="download_subset('product-analysis')">
                <b-card-text>
                  <h4>Cases analysed: <b-badge style="float: right;">{{ product_analysed }}</b-badge></h4>
                </b-card-text>
              </b-card>

              <br />
              <b-card title="Excluded From Analysis"  class="list-group-item-primary clickable" @click="download_subset('product-excluded-analysis')">
                <b-card-text>
                   <b-table striped hover :items="product_excluded_analysis" :fields="reasons_fields" thead-class="hidden_header">
                    <template v-slot:cell(n)="data">
                      <b-badge>{{ data.value }}</b-badge>
                    </template>
                  </b-table>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapActions } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      subset_url: process.env.VUE_APP_AXIOS_BASE_URL + '/kenya/consortium_report/get_consortium_subset',
      assessed: null,
      excluded: null,
      randomized: null,
      placebo_elibility: null,
      product_elibility: null,
      placebo_ltfu: [
        { category: 'Pregnancy', n: null },
        { category: 'Subject Moved', n: null },
        { category: 'Missed 3 consecutive visits', n: null }
      ],
      product_ltfu: [
        { category: 'Pregnancy', n: null },
        { category: 'Subject Moved', n: null },
        { category: 'Missed 3 consecutive visits', n: null }
      ],
      placebo_excluded_analysis: [
        { category: 'Some Reason', n: null }
      ],
      placebo_analysed: null,
      product_analysed: null,
      product_excluded_analysis: [
        { category: 'Some Reason', n: null }
      ],
      reasons_fields: [
        { key: 'category' },
        { key: 'n', tdClass: 'right-align'}
      ],
      pdf_src: '/static/report/report.pdf',
    };
  },
  computed: {},
  mounted: function() {
    let that = this;
     HTTP.get("/kenya/consortium_report/get_consortium_counts").then(response => {
      
      // Enrollment
      that.assessed = response.data.eligible;
      that.randomized = response.data.enrolled_count;
      that.excluded = response.data.excluded_total;

      // Allocation
      that.placebo_elibility = response.data.placebo_allocation_total;
      that.product_elibility = response.data.product_allocation_total;

      // Follow-up
      that.placebo_ltfu.forEach(element => {
        if(element.category == 'Pregnancy'){
          element.n = response.data.placebo_ltfu_pregnant;
        }
        if(element.category == 'Subject Moved'){
          element.n = response.data.placebo_ltfu_moved;
        }
        if(element.category == 'Missed 3 consecutive visits'){
          element.n = response.data.placebo_ltfu_missed;
        }
      });

      that.product_ltfu.forEach(element => {
        if(element.category == 'Pregnancy'){
          element.n = response.data.product_ltfu_pregnant;
        }
        if(element.category == 'Subject Moved'){
          element.n = response.data.product_ltfu_moved;
        }
        if(element.category == 'Missed 3 consecutive visits'){
          element.n = response.data.product_ltfu_missed;
        }
      });

      // Analysis
      
    });
  },
  methods: {
    download_pdf: function(){
      window.open(this.pdf_src);
    },
    download_subset: function(category){
      let that = this;
      HTTP.get(that.subset_url + '?category='+category).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'ConsortiumReport-'+category+'.csv');
        document.body.appendChild(fileLink);
        fileLink.click();
    }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    }
  }
};
</script>

<style>
.hidden_header {
  display: none;
}

.clickable {
  cursor: pointer;
}

.right-align {
  float: right;
}
</style>